export const yPatterns = [
  /* --------------------- Y -------------------- */
];
